import Image from 'next/image';

import type {
  ProductBenefitRecordModelType,
  ProductBenefitSectionRecordModelType,
} from '@/models/api';

export type ProductBenefitSectionType = {
  section?: ProductBenefitSectionRecordModelType;
};

export const ProductBenefitSection: React.FC<ProductBenefitSectionType> = ({
  section,
}) => {
  if (!section) return null;

  const { list } = section;

  return (
    <>
      {list && list.length > 0 && (
        <div className="flex w-full flex-wrap items-center justify-center space-x-4 rounded-md bg-off-grey px-3 py-4">
          {list.map((benefit: ProductBenefitRecordModelType, index: number) => (
            <div
              key={benefit.title}
              className={`flex min-h-[97px] flex-col items-center text-center ${
                index > 2 ? 'w-[99px] pt-2 md:pt-0' : 'w-[88px] md:w-[82px]'
              }`}
            >
              <Image
                width="50"
                height="50"
                src={benefit.icon?.url}
                alt={benefit.icon?.alt || ''}
              />
              <div className="pt-2 font-interSemibold text-xs">
                {benefit.title}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};
